import { TableCell, TableHead, TableRow, Tooltip, Typography } from '@mui/material';
import { IHeaderGrid } from '../../interfaces/grid/IHeaderGrid';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

export default function GridHeader(props: { headerProps: IHeaderGrid[] }) {
    return (
        <>
            <TableHead>
                <TableRow sx={{ borderBottom: '1px solid rgba(255,215,0,0.2)' }}>
                    {props.headerProps.map((item: IHeaderGrid, index: number) => (
                        <TableCell
                            key={index}
                            align={item.align}
                            padding={item.padding}
                            sx={{ color: 'text.secondary', fontSize: '0.72rem', fontWeight: 700, textTransform: 'uppercase', letterSpacing: 0.6 }}
                        >
                            {item.tooltip ? (
                                <Tooltip title={item.tooltip}>
                                    <Typography variant="inherit" sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                        {item.name}
                                        <InfoOutlinedIcon fontSize='small' color='info' />
                                    </Typography>
                                </Tooltip>
                            ) : (
                                item.name
                            )}
                        </TableCell>
                    ))}
                </TableRow>
            </TableHead>
        </>
    );
}
